"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.arrayDims=function(r){for(var e=[];Array.isArray(r);)e.push(r.length),r=r[0];return e};
